import type { FormCommonApiService } from 'src/app/service/api/formcommon-api.service';
import type { TratamientosControlMagramaLoaderContext, TratamientosControlMagramaSlotData } from './form-definition';
import { TratamientosControlMagramaMapper } from './tratamientos-control-magrama.mapper';

/**
 * MAGRAMA datasource for repeatable product dependencies in Tratamientos Control.
 */
export class TratamientosControlMagramaDataSource {
    constructor(private readonly formApi: Pick<FormCommonApiService, 'magramaDetalleProducto'>) {}

    public async loadSlot(
        context: TratamientosControlMagramaLoaderContext,
    ): Promise<TratamientosControlMagramaSlotData | null> {
        try {
            const rows = await this.formApi.magramaDetalleProducto.toPromise({ referencia: `'${context.referencia}'` } as never);

            return TratamientosControlMagramaMapper.mapRows(rows);
        } catch (error: unknown) {
            console.warn(`loadMagramaForRepeatableSlot(${context.slot}):`, error);

            return null;
        }
    }
}
